import { Navigate, useLocation } from 'react-router-dom';
import { useRootStore } from '@/contexts';
import jsCookie from 'js-cookie';
import { TOKEN_KEY } from '@/constants';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * 路由守卫组件，用于保护需要登录才能访问的路由
 * 如果用户未登录，将重定向到登录页
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { userStore } = useRootStore();
  const location = useLocation();
  
  // 检查用户是否已登录：检查 userStore.user 或 token
  const token = jsCookie.get(TOKEN_KEY);
  const isAuthenticated = userStore.user !== null || !!token;

  if (!isAuthenticated) {
    // 保存当前路径，登录后可以跳转回来
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

